// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventar-container {
  max-width: 800px;
}

.inventar-hinweis {
  font-family: 'Circular', sans-serif;
  color: var(--primary-dark);
  font-size: 0.92rem;
  margin-bottom: 1rem;
  padding: 0.5rem 0.75rem;
  background: var(--logistik-blass);
  border-left: 3px solid var(--logistik);
  border-radius: 0 8px 8px 0;
}

.inventar-toolbar {
  margin-bottom: 0.8rem;
}

.inventar-filter {
  margin-bottom: 1rem;
}

.inaktiv-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Circular', sans-serif;
  font-size: 0.9rem;
  color: var(--primary-dark);
  cursor: pointer;
}

.inaktiv-toggle input[type="checkbox"] {
  accent-color: var(--logistik);
}

/* Liste */
.inventar-liste {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

/* Karten */
.inventar-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
  padding: 0.8rem 1rem;
  transition: opacity 0.2s;
}

.inventar-card.inaktiv {
  opacity: 0.45;
}

.inventar-card.edit-card {
  background: var(--logistik-blass);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
}

.inventar-card-main {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.inventar-info {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
  flex: 1 1;
  flex-wrap: wrap;
}

.inventar-name {
  font-family: 'Staatliches', sans-serif;
  font-size: 1.3rem;
  text-transform: uppercase;
  color: var(--dunkelgruen);
  line-height: 1;
}

.inventar-anzahl {
  font-family: 'Circular', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: var(--logistik);
  white-space: nowrap;
}

.inventar-beschreibung {
  font-family: 'Circular', sans-serif;
  font-size: 0.88rem;
  color: var(--primary-dark);
}

/* Karten-Aktionen */
.inventar-card-actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
}

.aktiv-toggle-btn {
  min-height: auto !important;
  padding: 0.25rem 0.65rem !important;
  border-radius: 20px !important;
  font-size: 0.8rem !important;
  font-family: 'Circular', sans-serif !important;
  text-transform: none !important;
  cursor: pointer;
}

.aktiv-toggle-btn:disabled,
.inventar-container .logistik-btn:disabled,
.inventar-container .logistik-add-btn:disabled,
.inventar-container .logistik-import-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.aktiv-toggle-btn.aktiv {
  background: var(--logistik-hell) !important;
  color: var(--logistik) !important;
}

.aktiv-toggle-btn.aktiv:hover {
  background: var(--logistik-hell-hover) !important;
}

.aktiv-toggle-btn.inaktiv-btn {
  background: var(--blassgruen) !important;
  color: var(--primary-dark) !important;
}

.aktiv-toggle-btn.inaktiv-btn:hover {
  background: var(--hellgruen) !important;
}

/* Formular */
.inventar-form {
  padding: 0.25rem 0;
}

.inventar-form-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.75rem 1rem;
}

.inventar-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.inventar-field label {
  font-family: 'Staatliches', sans-serif;
  font-size: 0.95rem;
  color: var(--logistik);
  text-transform: uppercase;
}

.inventar-anzahl-field .logistik-input {
  width: 5rem;
}

.span-2 {
  grid-column: span 2;
}

.inventar-form-actions {
  margin-top: 0.75rem;
}

.inventar-container .logistik-print-link,
.inventar-container .logistik-print-link .print-text,
.inventar-container .logistik-print-link .material-symbols-outlined {
  color: var(--logistik) !important;
}

/* Druck */
@media print {
  .inventar-card {
    box-shadow: none;
    border: 1px solid #ddd;
    page-break-inside: avoid;
    break-inside: avoid;
    margin-bottom: 0.3rem;
  }

  .inventar-card.inaktiv {
    display: none;
  }

  .inventar-card-actions {
    display: none;
  }
}

@media (max-width: 650px) {
  .inventar-card-main,
  .inventar-info {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.35rem;
  }

  .inventar-card-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .inventar-form-grid {
    grid-template-columns: 1fr;
  }

  .span-2 {
    grid-column: span 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/logistik/inventar/Inventar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mCAAmC;EACnC,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,8BAA8B;EAC9B,4BAA4B;EAC5B,8CAA8C;EAC9C,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA,UAAU;AACV;EACE;IACE,gBAAgB;IAChB,sBAAsB;IACtB,wBAAmB;IAAnB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".inventar-container {\n  max-width: 800px;\n}\n\n.inventar-hinweis {\n  font-family: 'Circular', sans-serif;\n  color: var(--primary-dark);\n  font-size: 0.92rem;\n  margin-bottom: 1rem;\n  padding: 0.5rem 0.75rem;\n  background: var(--logistik-blass);\n  border-left: 3px solid var(--logistik);\n  border-radius: 0 8px 8px 0;\n}\n\n.inventar-toolbar {\n  margin-bottom: 0.8rem;\n}\n\n.inventar-filter {\n  margin-bottom: 1rem;\n}\n\n.inaktiv-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.9rem;\n  color: var(--primary-dark);\n  cursor: pointer;\n}\n\n.inaktiv-toggle input[type=\"checkbox\"] {\n  accent-color: var(--logistik);\n}\n\n/* Liste */\n.inventar-liste {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n/* Karten */\n.inventar-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);\n  padding: 0.8rem 1rem;\n  transition: opacity 0.2s;\n}\n\n.inventar-card.inaktiv {\n  opacity: 0.45;\n}\n\n.inventar-card.edit-card {\n  background: var(--logistik-blass);\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);\n}\n\n.inventar-card-main {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.inventar-info {\n  display: flex;\n  align-items: baseline;\n  gap: 0.75rem;\n  flex: 1;\n  flex-wrap: wrap;\n}\n\n.inventar-name {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.3rem;\n  text-transform: uppercase;\n  color: var(--dunkelgruen);\n  line-height: 1;\n}\n\n.inventar-anzahl {\n  font-family: 'Circular', sans-serif;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--logistik);\n  white-space: nowrap;\n}\n\n.inventar-beschreibung {\n  font-family: 'Circular', sans-serif;\n  font-size: 0.88rem;\n  color: var(--primary-dark);\n}\n\n/* Karten-Aktionen */\n.inventar-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex-shrink: 0;\n}\n\n.aktiv-toggle-btn {\n  min-height: auto !important;\n  padding: 0.25rem 0.65rem !important;\n  border-radius: 20px !important;\n  font-size: 0.8rem !important;\n  font-family: 'Circular', sans-serif !important;\n  text-transform: none !important;\n  cursor: pointer;\n}\n\n.aktiv-toggle-btn:disabled,\n.inventar-container .logistik-btn:disabled,\n.inventar-container .logistik-add-btn:disabled,\n.inventar-container .logistik-import-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.aktiv-toggle-btn.aktiv {\n  background: var(--logistik-hell) !important;\n  color: var(--logistik) !important;\n}\n\n.aktiv-toggle-btn.aktiv:hover {\n  background: var(--logistik-hell-hover) !important;\n}\n\n.aktiv-toggle-btn.inaktiv-btn {\n  background: var(--blassgruen) !important;\n  color: var(--primary-dark) !important;\n}\n\n.aktiv-toggle-btn.inaktiv-btn:hover {\n  background: var(--hellgruen) !important;\n}\n\n/* Formular */\n.inventar-form {\n  padding: 0.25rem 0;\n}\n\n.inventar-form-grid {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 0.75rem 1rem;\n}\n\n.inventar-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.inventar-field label {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 0.95rem;\n  color: var(--logistik);\n  text-transform: uppercase;\n}\n\n.inventar-anzahl-field .logistik-input {\n  width: 5rem;\n}\n\n.span-2 {\n  grid-column: span 2;\n}\n\n.inventar-form-actions {\n  margin-top: 0.75rem;\n}\n\n.inventar-container .logistik-print-link,\n.inventar-container .logistik-print-link .print-text,\n.inventar-container .logistik-print-link .material-symbols-outlined {\n  color: var(--logistik) !important;\n}\n\n/* Druck */\n@media print {\n  .inventar-card {\n    box-shadow: none;\n    border: 1px solid #ddd;\n    break-inside: avoid;\n    margin-bottom: 0.3rem;\n  }\n\n  .inventar-card.inaktiv {\n    display: none;\n  }\n\n  .inventar-card-actions {\n    display: none;\n  }\n}\n\n@media (max-width: 650px) {\n  .inventar-card-main,\n  .inventar-info {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 0.35rem;\n  }\n\n  .inventar-card-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .inventar-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .span-2 {\n    grid-column: span 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
